//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/TaggedObjectList.js";
import "../Routing/Routing.SelectPort.js";
import "../no/SelectObject.js";
import "../no/ObjectList.js";
let d=[[[0,"CutbackOption",1,0],[0,"ExtensionOption",1,0],[1,"List",0,"TaggedObjectList",0],[0,"MultiPort",1,"NXObject",0],[1,"PortSelection",0,"Routing.SelectPort",0],[0,"PreviewToggle",1,0]],[[[],"Model",{},0,0],[[],"UnModel",{},0,0],[[],"ModelAll",{},0,0],[[],"UnModelAll",{},0,0]],[]];
SPLM.Routing.ModelTerminalsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.ModelTerminalsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.ModelTerminalsBuilder.CutBackLocationOption = Object.freeze({
    "FromCharacteristic" : "FromCharacteristic", "UniformValue" : "UniformValue", "IndividualCutbacks" : "IndividualCutbacks"});

SPLM.Routing.ModelTerminalsBuilder.ExtensionValueOption = Object.freeze({
    "FromCharacteristic" : "FromCharacteristic", "UniformValue" : "UniformValue", "IndividualExtensions" : "IndividualExtensions"});

export default SPLM;